export const noMatch = { __noMatch: true } as const;
